export default {"src":"/_next/static/media/FinancialGroup-2_horizontal.2de27084.svg","height":162,"width":1066};